import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../contexts/TranslationContext.tsx';
import './css/PrivacyPolicyPage.css';

const LAST_UPDATED = '18.04.2026';

export default function AnticheatPolicyPage() {
  const { t } = useTranslation();

  const signalKeys = ['li1', 'li2', 'li3', 'li4'] as const;

  return (
    <div className="legal-page privacy-policy-page">
      <div className="legal-page-container">
        <h1 className="legal-page-title">{t('anticheatPolicy.title')}</h1>
        <p className="legal-page-updated">
          {t('anticheatPolicy.lastUpdatedLabel')}: {LAST_UPDATED}
        </p>

        <p className="legal-page-intro">{t('anticheatPolicy.intro')}</p>

        <section className="legal-page-section">
          <h2>{t('anticheatPolicy.whatIs.title')}</h2>
          <p>{t('anticheatPolicy.whatIs.p')}</p>
        </section>

        <section className="legal-page-section">
          <h2>{t('anticheatPolicy.howWorks.title')}</h2>
          <p>{t('anticheatPolicy.howWorks.p1')}</p>
          <p>{t('anticheatPolicy.howWorks.p2')}</p>
        </section>

        <section className="legal-page-section">
          <h2>{t('anticheatPolicy.signals.title')}</h2>
          <p>{t('anticheatPolicy.signals.intro')}</p>
          <ul>
            {signalKeys.map((key) => (
              <li key={key}>{t(`anticheatPolicy.signals.${key}`)}</li>
            ))}
          </ul>
          <p>{t('anticheatPolicy.signals.footer')}</p>
        </section>

        <section className="legal-page-section">
          <h2>{t('anticheatPolicy.limits.title')}</h2>
          <p>{t('anticheatPolicy.limits.p')}</p>
        </section>

        <section className="legal-page-section">
          <h2>{t('anticheatPolicy.status.title')}</h2>
          <p>{t('anticheatPolicy.status.p')}</p>
        </section>

        <section className="legal-page-section">
          <h2>{t('anticheatPolicy.related.title')}</h2>
          <p>
            {t('anticheatPolicy.related.pBefore')}
            <Link to="/privacy" className="legal-page-inline-link">{t('anticheatPolicy.related.linkPrivacy')}</Link>
            {t('anticheatPolicy.related.pMiddle')}
            <Link to="/terms" className="legal-page-inline-link">{t('anticheatPolicy.related.linkTerms')}</Link>
            {t('anticheatPolicy.related.pSuffix')}
          </p>
        </section>
      </div>
    </div>
  );
}
